/**
 * Endpoint Manager Shim
 * This file provides backwards compatibility for services that reference the old endpoint manager
 * For the new admin authentication system, use adminEndpointManager.js instead
 * For config service endpoints, use configEndpointManager.js instead
 */

import { getAdminEndpoint } from './adminEndpointManager';
import { getConfigEndpoint, hasConfigEndpoint } from './configEndpointManager';

// Re-export from adminEndpointManager for admin auth
export { getAdminEndpoint } from './adminEndpointManager';

// Re-export from configEndpointManager for config service
export { 
  getConfigEndpoint, 
  setConfigEndpoint, 
  hasConfigEndpoint,
  clearConfigEndpoint 
} from './configEndpointManager';

// Legacy exports for backwards compatibility
// These are kept for services that still use the old endpoint system

export const resetDynamicEndpoints = () => {
  console.log('[EndpointManager Shim] resetDynamicEndpoints called (no-op)');
};

export const loadStoredEndpoints = () => {
  console.log('[EndpointManager Shim] loadStoredEndpoints called (no-op)');
  return [];
};

export const cleanupAuthServiceReferences = () => {
  console.log('[EndpointManager Shim] cleanupAuthServiceReferences called (no-op)');
};

export const getSelectedEndpoint = () => {
  // Return the config service endpoint for dynamic services
  // This is the endpoint from PublicDNSManager (first entry)
  const configEndpoint = getConfigEndpoint();
  if (configEndpoint) {
    console.log('[EndpointManager Shim] getSelectedEndpoint (config):', configEndpoint);
    return configEndpoint;
  }
  
  // No fallback - if no config endpoint is set, return null
  // This ensures we fail explicitly if no DNS is available
  console.log('[EndpointManager Shim] getSelectedEndpoint: No config endpoint available');
  return null;
};

export const getAvailableEndpoints = () => {
  console.log('[EndpointManager Shim] getAvailableEndpoints called (no-op)');
  return [];
};

export const hasPrimaryEndpoint = () => {
  // Check if we have a config endpoint or admin endpoint
  return hasConfigEndpoint() || !!getAdminEndpoint();
};

export const getPrimaryEndpoint = () => {
  const endpoint = getSelectedEndpoint();
  return endpoint ? { url: endpoint } : null;
};

export const getEndpointStatus = () => {
  const endpoint = getSelectedEndpoint();
  return {
    total: 1,
    healthy: 1,
    primary: { url: endpoint },
    hasPrimary: !!endpoint,
    endpoints: [{ url: endpoint, isHealthy: true }]
  };
};

export const discoverAndValidateEndpoints = async () => {
  const endpoint = getSelectedEndpoint();
  return {
    success: true,
    primaryEndpoint: { url: endpoint },
    healthyEndpoints: [{ url: endpoint, isHealthy: true }],
    allEndpoints: [{ url: endpoint, isHealthy: true }],
    hasPrimary: !!endpoint
  };
};

export const refreshEndpointStatus = async () => {
  console.log('[EndpointManager Shim] refreshEndpointStatus called (no-op)');
  return getEndpointStatus();
};
